/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import type { TriviaGame } from "@packages/sdk";
import { useBranch } from "@packages/sdk";
import { END_OF_BROWSER_ASYNC_QUEUE, ShareModal, useModal } from "@packages/ui";

const CORRECT_CIRCLE = "\ud83d\udfe2";
const WRONG_CIRCLE = "\ud83d\udd34";

export const useShareTrivia = () => {
  const { trivia } = useBranch();
  const modal = useModal(ShareModal);
  const t = useTranslations();

  return async (game: TriviaGame) => {
    const link = await trivia({
      date: game?.available_at,
    });
    setTimeout(() => {
      modal.show({
        color: game?.images?.color_hex,
        imgSrc: game?.images?.large,
        title: t("web_trivia_share_text", {
          "0": game?.summary?.total_seconds_elapsed ?? 0,
          "1":
            game?.questions
              ?.map((q) =>
                (q.answers.find((a) => a.id === q.user_answer.answer_id)
                  ?.correct ?? false)
                  ? CORRECT_CIRCLE
                  : WRONG_CIRCLE,
              )
              .join("") ?? "",
        }),
        link,
      });
    }, END_OF_BROWSER_ASYNC_QUEUE);
  };
};
